export var ReferenceValuesTypes;
(function (ReferenceValuesTypes) {
    ReferenceValuesTypes["BRANDS"] = "brand";
    ReferenceValuesTypes["MARKETS"] = "market";
    ReferenceValuesTypes["NAVIGATIONMENU"] = "navigation-menu";
    ReferenceValuesTypes["WEBSITE"] = "website";
    ReferenceValuesTypes["CATALOGSERVICES"] = "catalog-service";
    ReferenceValuesTypes["CATALOGCATEGORIES"] = "catalog-category";
})(ReferenceValuesTypes || (ReferenceValuesTypes = {}));
